// The approved design has no detail PAGE — a record opens in a drawer beside
// the list. But a record still needs an address: links were shared, and the
// first build shipped real detail routes.
//
// So `/reinsurance/treaties/:id` redirects to `/reinsurance/treaties?selected=:id`,
// which opens the drawer on that row. Old links keep working, and there is
// only ever one UI for a record.

import { Redirect, useParams } from 'react-router-dom';
import React from 'react';

export default function RedirectToList({ to }) {
  const { id } = useParams();
  return <Redirect to={`${to}?selected=${id}`} />;
}
